import { ActivityRetentionDialog } from './ActivityRetentionDialog'
import { ConnectionDetailDialog } from './ConnectionDetailDialog'
import type { ConnectionDetail, ConnectionType } from './detailTypes'

export function ConnectionEditDialog({
  row,
  action,
  type,
  onClose,
}: {
  row: ConnectionDetail
  action: string
  type?: ConnectionType
  onClose: () => void
}) {
  if (action === 'retention') return <ActivityRetentionDialog row={row} onClose={onClose} />
  return <ConnectionDetailDialog row={row} action={action} type={type} onClose={onClose} />
}
